import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const McoInvRbtLedgerPymtList = ({ mcoInvId, pymtId }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (mcoInvId) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('mcoInvId', mcoInvId));
      }

      if (pymtId) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('pymtId', pymtId));
      }
    },
    [mcoInvId, pymtId],
  );

  return <EntityList entity="MCO_INV_RBT_LEDGER_PYMT" augRowsReq={augRowsReq} />;
};
